import React from "react";
import { motion } from "framer-motion";
import { buildWaLink } from "../data/site";
import { useLang } from "../data/i18n";
import { SunRays } from "./Decor";
import { BrandSymbol } from "./BrandLogo";

const BG =
    "https://images.pexels.com/photos/12194603/pexels-photo-12194603.jpeg";

export default function CTABand() {
    const { t } = useLang();
    return (
        <section className="relative overflow-hidden" data-testid="cta-band">
            <img
                src={BG}
                alt=""
                className="absolute inset-0 w-full h-full object-cover"
                aria-hidden="true"
            />
            {/* Soft radial vignette — darker at center where text sits, lighter on edges so the flowers show through */}
            <div
                className="absolute inset-0"
                style={{
                    background:
                        "radial-gradient(ellipse 60% 55% at center, rgba(10,30,46,0.62) 0%, rgba(10,30,46,0.42) 45%, rgba(10,30,46,0.18) 100%)",
                }}
                aria-hidden="true"
            />

            <SunRays className="absolute -bottom-24 left-1/2 -translate-x-1/2 w-[560px] opacity-25" color="#EB6741" />
            <BrandSymbol size={140} className="absolute top-10 right-10 opacity-30" />
            <BrandSymbol size={110} className="absolute bottom-10 left-10 opacity-20" />

            <div className="relative max-w-[1400px] mx-auto px-5 md:px-10 py-24 md:py-40 text-center">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                    className="relative inline-block mb-6"
                >
                    {/* Soft halo behind the eyebrow for extra contrast on light-sky patches */}
                    <span
                        aria-hidden="true"
                        className="absolute inset-0 -mx-6 -my-3 pointer-events-none"
                        style={{
                            background:
                                "radial-gradient(ellipse 60% 100% at center, rgba(10,30,46,0.55) 0%, rgba(10,30,46,0.25) 55%, rgba(10,30,46,0) 100%)",
                            filter: "blur(6px)",
                        }}
                    />
                    <p
                        className="relative text-sm md:text-base uppercase tracking-[0.32em] text-lagoon font-bold inline-flex items-center gap-4 [text-shadow:0_2px_8px_rgba(0,0,0,0.6)]"
                    >
                        <span className="inline-block w-10 h-px bg-lagoon" />
                        {t.ctaband.kicker}
                        <span className="inline-block w-10 h-px bg-lagoon" />
                    </p>
                </motion.div>
                <motion.h2
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.9, delay: 0.1 }}
                    className="font-serif font-normal text-cream text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight max-w-4xl mx-auto [text-shadow:0_4px_30px_rgba(0,0,0,0.55)]"
                >
                    {t.ctaband.titleA}
                    <br />
                    {t.ctaband.titleB}{" "}
                    <em className="coral-italic">{t.ctaband.titleC}</em> ?
                </motion.h2>
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.4 }}
                    className="mt-12"
                >
                    <a
                        href={buildWaLink(t.ctaband.waMessage)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-coral"
                        data-testid="cta-band-button"
                    >
                        {t.ctaband.cta}
                        <span>→</span>
                    </a>
                </motion.div>
            </div>
        </section>
    );
}
